/*
 * @Description: 订单利润管理
 * @Author: 杨志航
 * @Date: 2026-08-12 16:17:31
 */
import React from 'react'
import { Switch, Route } from 'react-router-dom'
import Main from './Main'
import First from './First'
import Second from './Second'
import Order from './Order'

const ProfitManage = ({ match, history }) => {

  return (
    <Switch>
      <Route path={match.path + '/first'} component={First} />
      <Route path={match.path + '/second'} component={Second} />
      <Route path={match.path + '/order'} component={Order} />
      <Route component={Main} />
    </Switch>
  )
}

export default ProfitManage